<button [attr.id]="'btnDialogClose'" mat-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<h1 mat-dialog-title>{{'dialog.modal_lesson_preview_title' | translate}}</h1>
<div mat-dialog-content>
  <!-- ng-template to ensure that the generated components end up in this place -->
  <ng-template #lessonPreviewContainer> </ng-template>
</div>
